var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('dt',[_c('tt',[_vm._v(_vm._s(_vm.directive))])],1),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_setup.entry.help))])])
}
var staticRenderFns = []

export { render, staticRenderFns }